<template>
	<li class="post row py-0 mx-0 align-items-center" style="min-height: 60px; display: flex" >
		<div class="col px-0 py-2">

		<div class="row my-auto mx-0">

			<div v-if="isEditableVal">
				<span class="column-drag-handle grabbable"><i class="fontello icon-menu"></i></span>
			</div>
			<div>
				<i class="fontello icon-calendar-check-o mr-2"/>

			</div>
			<div class="col p-0 h-100">
				<div class="my-auto">{{ programStep.name}}</div>
				<div v-if="programStep.goal.length > 0" class="text-muted"><small>{{ 'Goal: ' + programStep.goal}}</small></div>
				<div v-if="programStep.subStepList && programStep.subStepList.length > 0" class="my-2">
					<small class="text-muted">
					<div v-for="(plan, index) in programStep.subStepList" :key="index" class="row mx-0 pb-2">
						<div>{{plan.subName}}:</div> <div class="col">{{plan.name}}</div>
					</div>
					</small>
				</div>
			</div>
			<div v-if="program.isProcess()">

				<div v-if="isInClientMode" class="float-right">
					<span v-if="programStep.dueDateTs > 0"
						  class="mr-2"
					:class="{'text-danger': programStep.isDueFor(userProfile.id)}">
						Due by {{programStep.dueDateFormatted()}}
					</span>
						<input
							class="extendedClickArea"
							:checked="isItemChecked(programStep, sectionIndex, itemIndex)"
							type="checkbox"
							@mouseenter="mouseHoverItemIndex = indexPathToNumber(sectionIndex, itemIndex); "
							@mouseleave="mouseHoverItemIndex = -1"
							@click.stop
							@click.prevent
							@click="notifyItemToggleCompletion(programStep)">
				</div>
				<div v-else-if="isInCoachMode" class="float-right text-right">
					<small>
						<span v-if="isItemCompletedCoach(programStep)">
							<span class="mr-2">Completed</span>
							<ToolTipView :analyticsProps="{label: 'Completed task', ...analyticsPropsMethod()}" >
								<template #icon><span  class="dot badge-success"></span></template>
								This task was completed
							</ToolTipView>
						</span>
						<span v-else>
							<span v-if="programStep.dueDateTs > 0"
								  class="mr-2">Due by {{programStep.dueDateFormatted()}}</span>

							<span v-else class="mr-2">Not completed</span>
							<ToolTipView :analyticsProps="{label: 'Not completed due task', ...analyticsPropsMethod()}"
								v-if="programStep.isDueFor(userProfile.id)">
								<template #icon><span  class="dot badge-danger"></span></template>
								This task is not yet completed and is due
							</ToolTipView>
							<ToolTipView :analyticsProps="{label: 'Not completed task', ...analyticsPropsMethod()}"  v-else>
								<template #icon><span  class="dot badge-warning"></span></template>
								This task is not yet completed
							</ToolTipView>

						</span>
					</small>
				</div>
			</div>
		</div>

		</div>
	</li>
</template>

<script>
	import BaseRow from "./BaseRow"
	import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";

	export default {
		name: "TaskRow",
		components: {ToolTipView},
		extends: BaseRow,
		props:{
			tooltipAnalyticsProps: Object
		}
	}
</script>

<style>

</style>
